import fetchWithToken from './api';
import * as authService from './authService';
import * as tokenService from './tokenService';
import * as userService from './userService';
import * as buttonService from './buttonService';

export default fetchWithToken;

export const {
  checkAuthStatus, 
  login, 
  logout,
  googleLogin,
  googleLoginWithCode
} = authService;

export const { 
  refreshAccessToken, 
  setupTokenRefresh 
} = tokenService;

export const {
  updateOnboardingStage,
  getUserData
} = userService;

export const {
  getButtonId
} = buttonService;
